import UserInfo from "./UserInfo";
import {connect} from 'react-redux';
import {loadMe, setAvatar} from "../../store/actions"

const mapStateToProps = state => ({
    me: state.me.me,
});

const mapDispatchToProps = dispatch => ({
    loadMe: () => dispatch(loadMe()),
    setAvatar: file => dispatch(setAvatar(file))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserInfo);
